import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Events from '@/hooks/events';
import actions from '../constants';

const useRefreshNotifications = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ event, page }) => handler({
    type: actions.REFRESH_NOTIFICATIONS, category, code, event, page,
  }), [category, code]);
};

const useFetchNotifications = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({
    event, append, page, pageSize,
  }) => handler({
    type: actions.FETCH_NOTIFICATIONS, category, code, event, append, page, pageSize,
  }), [category, code]);
};

const useShowNotification = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ event, notificationCode }) => handler({
    type: actions.SHOW_NOTIFICATION, category, code, event, notificationCode,
  }), [category, code]);
};

const useUpdateNotificationsFilter = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ event, value }) => handler({
    type: actions.UPDATE_NOTIFICATIONS_FILTER, category, code, event, value,
  }), [category, code]);
};

export default {
  useFetchNotifications,
  useRefreshNotifications,
  useShowNotification,
  useUpdateNotificationsFilter,
  useHideNotification: () => Events.useSimpleDispatch(actions.HIDE_NOTIFICATION),
};
